import { memo } from 'react';
import { DefaultValueConfig } from '@headless-workspace/config';
import { getIcon } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import { ConnectionBannerItem } from '../../../../../src';
import { ConnectionBannerItemWrapperProps } from './ConnectionBannerItemWrapper';

export const StaticConnectionBanner: ComponentMemo<ConnectionBannerItemWrapperProps> = memo((props) => {
    return (
        <ConnectionBannerItem
            key={props.id}
            Icon={getIcon(props.iconName)}
            href={props.href ?? DefaultValueConfig.href}
            dataLayer={{
                label: props.connectionDataLayer,
            }}
            isRedDot={props.isRedDot}
            {...props}
        />
    );
});

StaticConnectionBanner.displayName = 'StaticConnectionBanner';
